import firebase from './firebase'

export * from './firebase'
export default firebase
